import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { CtaBand } from '../components/CtaBand';
import { Reveal } from '../components/showcase/Reveal';
import { ResponseTimeVignette } from '../components/showcase/ResponseTimeVignette';
import { howWeWorkItems } from '../data/content';
import { usePageTitle } from '../hooks/usePageTitle';
export function About() {
  usePageTitle('About | Viridia Analytics');
  return <>
      <PageHeader eyebrow="About" title="We build response systems for businesses that pay to make the phone ring." body="Viridia Analytics is a Phoenix-based company founded by Kevin Rogers." data-id="element-469" data-mp="377drkagaaxp2" />

      <section aria-labelledby="why-title" className="border-b border-white/5 bg-ink-800" data-id="element-470" data-mp="2x8evdrcpguiy">
        <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-471" data-mp="1gtwvb8o2u6ii">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-472" data-mp="1lukjlmkx8991">
            Our reason
          </p>
          <h2 id="why-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-473" data-mp="1uil3jgxrycix">
            Why Viridia exists.
          </h2>
          <div className="mt-8 max-w-3xl space-y-5 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-474" data-mp="23jrp44fa6dj1">
            <p data-id="element-475" data-mp="1ylhrln6330u9">
              Viridia Analytics is a Phoenix-based company founded by Kevin Rogers that
              builds response systems for lead-driven businesses.
            </p>
            <p data-id="element-476" data-mp="28h1i1u1vp7bm">
              The story is simple. Lead-driven businesses pay real money to make the phone
              ring and then lose the race to answer it. We started in home services, where
              a missed call costs a job, and built the system that answers every lead in
              seconds and books it.
            </p>
          </div>
        </div>
      </section>

      <section aria-labelledby="results-title" className="border-b border-white/5 bg-ink-900" data-id="element-477" data-mp="2r9dkegsj88lr">
        <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-478" data-mp="1owhejk4vdyvh">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-479" data-mp="1sx1a4j9soufi">
            Measured
          </p>
          <h2 id="results-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-480" data-mp="1xu01iu22qna0">
            The results that sent us here.
          </h2>

          <figure className="mt-12" data-id="element-481" data-mp="2cjyxcq65pmmb">
            <figcaption className="text-sm font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-482" data-mp="2ciw78kgnro7g">
              Home services client, same response-time system:
            </figcaption>
            <Reveal className="mt-6" data-id="element-483" data-mp="2ljudl9ekk7t7">
              <ResponseTimeVignette data-id="element-484" data-mp="2lit1r2pqbhaf" />
            </Reveal>
          </figure>

          <p className="mt-10 max-w-3xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-485" data-mp="m9cgv2m0ps2u">
            Real estate is the harsher version of the same race. The lead costs more and
            the buyer signs with whoever answers first. That is why we built the real
            estate version.
          </p>
        </div>
      </section>

      <section aria-labelledby="how-we-work-title" className="border-b border-white/5 bg-ink-800" data-id="element-486" data-mp="9xjtwcetqy8z">
        <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-487" data-mp="4yz3f4pdjsxq">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-488" data-mp="12m7julaiqbsv">
            Terms
          </p>
          <h2 id="how-we-work-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-489" data-mp="xmmm2e7349hq">
            How we work.
          </h2>

          <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-490" data-mp="oleqi3vydmrc">
            {howWeWorkItems.map((item, index) => <li key={item} className="h-full" data-id="element-491" data-mp="3dfll84zwb1pj" data-mpi={index}>
                <Reveal delay={0.07 * index} className="h-full" data-id="element-492" data-mp="39c5m920csp9o">
                  <div className="flex h-full items-start gap-3 rounded-xl border border-white/10 bg-ink-700 p-6 text-sm font-medium text-white/80" data-id="element-493" data-mp="39f1lqurunm08">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-494" data-mp="15vqybj9ai65n" />
                    <span className="leading-relaxed" data-id="element-495" data-mp="w4mmgsewv1f1">{item}</span>
                  </div>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBand title="Talk to the people who built the system." body="Fifteen minutes on your lead sources, your response times, and what a fully answered pipeline is worth to your team." data-id="element-496" data-mp="1otjrhtu431pu" />
    </>;
}